import { init } from 'src/services/network';
import store from 'src/store';

/**
 * Initialize network service.
 *
 * @param {Object} params
 * @param {VueRouter} params.router
 */
export default ({ router }) => {
  init({ router, store: store() });
};
